import { ConfigurationType } from '@server/parser';
import { useCallback } from 'react';
import { useDocumentationApiFacade } from '../../../../../apis/facades/useDocumentationApiFacade';
import { ConfigurationItem } from '../../../../documentation/dependencies/DependenciesTypes';
import { translateNewConfigurationTypeKeysToOldVersion } from '../../../../documentation/dependencies/helpers';
import { mapMissingInternalIdToMetadataId } from '../../../../documentation/helpers';

export const useFetchConfigurationItem = () => {
  const { get_metadataByMetadataId } = useDocumentationApiFacade();

  const fetchConfigurationItem = useCallback(
    async (metadataElementId: string, crmOrgId: string): Promise<ConfigurationItem> => {
      const cardType = await get_metadataByMetadataId(metadataElementId, crmOrgId);

      switch (cardType.type) {
        case 'field': {
          const type = ConfigurationType.fields;
          return {
            ...cardType.metadata,
            id: cardType.metadata.name,
            parentType: type,
            type: cardType.metadata.type,
            _oldId: cardType.metadata.name,
          };
        }
        case 'configuration': {
          const type = translateNewConfigurationTypeKeysToOldVersion(
            cardType.metadata.type as string,
          );
          return {
            ...cardType.metadata,
            parentType: type,
            type,
            ...mapMissingInternalIdToMetadataId(cardType.metadata),
          };
        }
        case 'object': {
          const type = ConfigurationType.objects;
          return {
            ...cardType.metadata,
            id: cardType.metadata.name,
            parentType: type,
            type,
            objectName: cardType.metadata.name,
            _oldId: cardType.metadata.name,
          };
        }
        default:
          throw new Error('Invalid card type');
      }
    },
    [get_metadataByMetadataId],
  );

  return { fetchConfigurationItem };
};
